import { render, staticRenderFns } from "./UserGroupAdd.vue?vue&type=template&id=8b1bf58a&scoped=true&"
import script from "./UserGroupAdd.vue?vue&type=script&lang=js&"
export * from "./UserGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupAdd.vue?vue&type=style&index=0&id=8b1bf58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1bf58a",
  null
  
)

export default component.exports